import * as Yup from 'yup'
import { TabOption } from '../../../../shared/components/FormTabHeader';
export interface ICouponDetailsModel {
    id: string; // BaseDTO'dan gelebilir diye ekledim
    status: string;
    ruleName: string;

    rentalStartDate: string;   // "yyyy-MM-dd"
    rentalEndDate: string;
    requestStartDate: string;
    requestEndDate: string;

    quickProcess: boolean;

    minDays: number;
    maxDays: number;
    increaseDecrease: number;
    giftDays: number;

    dependentOnPromotionCode: boolean | string;
    promotionCode: string;
    codeType: string;
    calculation: string;

    monday: boolean;
    tuesday: boolean;
    wednesday: boolean;
    thursday: boolean;
    friday: boolean;
    saturday: boolean;
    sunday: boolean;
}

export const initialCoupon: ICouponDetailsModel = {
    id: '',
    status: "",
    ruleName: "",

    rentalStartDate: "",
    rentalEndDate: "",
    requestStartDate: "",
    requestEndDate: "",

    quickProcess: false,

    minDays: 0,
    maxDays: 0,
    increaseDecrease: 0,
    giftDays: 0,

    dependentOnPromotionCode: false,
    promotionCode: "",
    codeType: "",
    calculation: "",

    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    sunday: false,
};



export const validationCouponDetails = Yup.object({
    status: Yup.string().required('Durum zorunludur'),
    ruleName: Yup.string().required('Kural adı zorunludur'),

    rentalStartDate: Yup.string().required('Kiralama başlangıç tarihi zorunludur'),
    rentalEndDate: Yup.string().required('Kiralama bitiş tarihi zorunludur'),

    requestStartDate: Yup.string().required('Talep başlangıç tarihi zorunludur'),
    requestEndDate: Yup.string().required('Talep bitiş tarihi zorunludur'),

    minDays: Yup.number().required('Minimum gün zorunludur')
        .min(1, 'Minimum gün en az 1 olmalıdır'),

    maxDays: Yup.number().required('Maksimum gün zorunludur'),
    increaseDecrease: Yup.number().required('Artış/Azalış zorunludur'),
    giftDays: Yup.number().required('Hediye gün zorunludur'),

    promotionCode: Yup.string().required('Promosyon kodu zorunludur'),
    codeType: Yup.string().required('Kod tipi zorunludur'),
    calculation: Yup.string().required('Hesaplama alanı zorunludur'),
})

export const tabOptions: TabOption<'form' | 'list'>[] = [
    { key: 'form', title: 'Kiralama Kuralları', icon: 'bi bi-tools' },

]

export const YES_OR_NO = [
    { value: 'true', label: 'Görünsün' },
    { value: 'false', label: 'Görünmesin' },
] as const
export const STATUS_OPTIONS = [
    { value: 'ACTIVE', label: 'Aktif' },
    { value: 'PASSIVE', label: 'Pasif' },
] as const

export const CODE_TYPE_OPTIONS = [
    { value: 'SINGLE', label: 'Tekli' },
    { value: 'MULTIPLE', label: 'Çoklu' },
] as const
export const CALCULATION_OPTIONS = [
    { value: 'RATE', label: 'Oran' },
    { value: 'AMOUNT', label: 'Tutar' },
] as const
